// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"f3ee935e","83":"af0da368","282":"da446172","368":"0eb97109","411":"acec2a08","453":"75cd1e74","801":"f5b5b421","812":"58b48d4e","964":"f5422881","974":"cd96c019"}[chunkId] + ".chunk.js";
};